import { render } from "./UserAdmin.vue?vue&type=template&id=5750f9aa&scoped=true"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"

import "./UserAdmin.vue?vue&type=style&index=0&id=5750f9aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5750f9aa"]])

export default __exports__